<template>
  <div style="height: 100vh; display: flex; flex-direction: column;">
    <div
      style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid #eee; height: 51px;"
    >
      <div
        @click="() => this.onClose && this.onClose()"
        style="font-weight: 600; font-size: 16px; cursor: pointer; display: flex; align-items: center; gap: 5px;"
      >
        <q-icon name="fas fa-chevron-left" class="back__icon" />
        Пересорт материала
      </div>
      <q-btn icon="close" flat round dense @click="() => this.onClose && this.onClose()" />
    </div>
    <div class="change__header">
      <div v-if="projectName">
        <div style="font-size: 14px; color: #666;">Проект:</div>
        <div style="font-weight: 500; font-size: 16px;">{{ projectName }}</div>
      </div>
    </div>
    <div style="padding: 16px;">
      <div class="q-mb-md">
        <label class="text-body2 text-grey-8">Подъезд</label>
        <q-select
          v-model="selectedEntranceId"
          :options="entranceOptions"
          option-value="project_entrance_id"
          option-label="label"
          emit-value
          map-options
          dense
          outlined
          clearable
          placeholder="Выберите подъезд"
          @update:model-value="onEntranceChange"
          style="max-width: 280px;"
        />
      </div>
      <q-linear-progress v-if="isFetching" indeterminate class="q-mb-md" />
      <div v-if="selectedEntranceId && materialsByEntrance.length">
        <p style="margin-bottom: 5px;">Материалы (пересорт, подъезд):</p>
        <CustomTable
          title=""
          :rowsData="materialsByEntrance"
          :columns="[{}, {}]"
          :loading="isFetching"
          hide-top-title
          :custom-body="true"
          :bottomRow="true"
          :allWidth="true"
          :striped="true"
          :bordered="true"
          :hoverless="true"
          :withoutHead="true"
          :sticky-header="false"
          separator="cell"
        >
          <template #customBody="props">
            <q-tr :props="props">
              <q-td align="left" vertical-align="center" style="border-left:1px solid rgba(0,0,0,.12);">
                {{ props.row.material_id }} - {{ props.row.material_name }}
              </q-td>
              <q-td align="center" vertical-align="center" style="width:150px; border-left:1px solid rgba(0,0,0,.12);">
                <Clickable @click="openReplaceModal(props.row)">
                  Заменить
                </Clickable>
              </q-td>
            </q-tr>
          </template>
        </CustomTable>
      </div>
      <div v-else-if="selectedEntranceId && !isFetching">
        <p class="text-grey-7">Нет материалов от команды проекта.</p>
      </div>
      <div v-else-if="!selectedEntranceId && entranceOptions.length > 0">
        <p class="text-grey-7">Выберите подъезд.</p>
      </div>
      <div v-else-if="!isFetching && !selectedEntranceId && entranceOptions.length === 0">
        <p class="text-grey-7">Нет материалов от команды проекта.</p>
      </div>
    </div>
  </div>

  <!-- Модалка: выбор нового материала из справочника — тот же поиск, что в «Добавить позицию пакета» -->
  <q-dialog v-model="showReplaceModal" persistent>
    <q-card style="min-width: 480px; max-width: 600px;">
      <q-card-section>
        <div class="text-h6">Заменить на материал из справочника</div>
      </q-card-section>
      <q-card-section class="q-pt-none">
        <CustomInputDropdown
          label="Поиск материала"
          placeholder="Поиск"
          :value="materialSearchValue"
          :options="materialOptions"
          optionValueKey="material_id"
          optionLabelKey="label"
          :loading="materialSearchLoading"
          @change_input="onMaterialSearch"
          @select_item="onMaterialSelect"
        />
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat label="Отмена" v-close-popup @click="closeReplaceModal" />
        <q-btn
          flat
          label="Заменить"
          color="primary"
          :disable="!selectedNewMaterialId"
          :loading="replaceLoading"
          @click="confirmReplace"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import Clickable from '@/components/common/Clickable.vue';
import CustomTable from '@/components/common/CustomTable';
import CustomInputDropdown from '@/components/form/CustomInputDropdown';
import { getProjectEntrances, getResortMaterials, resortMaterialUpd } from './services';
import { searchMaterials } from '@/views/PackageEntry/services';
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar';

export default {
  name: 'ResortMaterial',
  components: { CustomTable, Clickable, CustomInputDropdown },
  props: ['onClose', 'projectId', 'projectData'],
  data() {
    return {
      entranceOptions: [],
      selectedEntranceId: null,
      allMaterials: [],
      isFetching: false,
      showReplaceModal: false,
      replacingRow: null,
      materialSearchValue: '',
      materialOptions: [],
      materialSearchLoading: false,
      selectedNewMaterialId: null,
      replaceLoading: false,
      materialSearchController: null,
    };
  },
  computed: {
    projectName() {
      if (!this.projectData) return '';
      return this.projectData.resident_name && this.projectData.project_type_name
        ? `${this.projectData.resident_name} - ${this.projectData.project_type_name}`
        : '';
    },
    materialsByEntrance() {
      if (!this.selectedEntranceId || !this.allMaterials.length) return [];
      return this.allMaterials.filter(
        (r) => r.project_entrance_id != null && Number(r.project_entrance_id) === Number(this.selectedEntranceId)
      );
    },
  },
  methods: {
    async loadEntrances() {
      if (!this.projectId) return;
      const res = await getProjectEntrances(this.projectId);
      const list = (res || []).map((item) => ({
        ...item,
        label: item.entrance != null ? `Подъезд ${item.entrance}` : `Подъезд (ID ${item.project_entrance_id})`,
      }));
      this.entranceOptions = list;
      if (list.length > 0 && this.selectedEntranceId == null) {
        const sorted = list.slice().sort((a, b) => (a.project_entrance_id || 0) - (b.project_entrance_id || 0));
        this.selectedEntranceId = sorted[0].project_entrance_id;
      }
    },
    async loadMaterials() {
      if (!this.projectId) return;
      this.isFetching = true;
      try {
        const res = await getResortMaterials(this.projectId);
        this.allMaterials = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
      } catch (e) {
        this.allMaterials = [];
      }
      this.isFetching = false;
    },
    onEntranceChange() {
      // materialsByEntrance is computed from allMaterials + selectedEntranceId
    },
    openReplaceModal(row) {
      this.replacingRow = row;
      this.materialSearchValue = '';
      this.materialOptions = [];
      this.selectedNewMaterialId = null;
      this.showReplaceModal = true;
    },
    closeReplaceModal() {
      this.replacingRow = null;
      this.showReplaceModal = false;
      if (this.materialSearchController) {
        this.materialSearchController.abort();
        this.materialSearchController = null;
      }
    },
    async onMaterialSearch(searchValue) {
      this.materialSearchValue = searchValue || '';
      if (!searchValue || String(searchValue).trim().length < 2) {
        this.materialOptions = [];
        return;
      }
      if (this.materialSearchController) this.materialSearchController.abort();
      this.materialSearchController = new AbortController();
      this.materialSearchLoading = true;
      try {
        const res = await searchMaterials(searchValue.trim(), this.materialSearchController.signal);
        this.materialOptions = res || [];
      } catch (e) {
        this.materialOptions = [];
      }
      this.materialSearchLoading = false;
      this.materialSearchController = null;
    },
    onMaterialSelect(materialId, materialData) {
      this.selectedNewMaterialId = materialId || null;
      this.materialSearchValue = materialData && materialData.label ? materialData.label : (materialData && materialData.material_name ? materialData.material_name : '');
      this.materialOptions = [];
    },
    async confirmReplace() {
      if (!this.selectedNewMaterialId || !this.replacingRow) return;
      this.replaceLoading = true;
      try {
        await resortMaterialUpd({
          project_id: this.projectId,
          project_entrance_id: this.selectedEntranceId,
          old_material_id: this.replacingRow.material_id,
          new_material_id: this.selectedNewMaterialId,
        });
        this.showSucceedSnackbar('Материал заменён');
        this.closeReplaceModal();
        await this.loadMaterials();
      } catch (e) {
        const msg = e?.response?.data?.error || e?.message || 'Ошибка замены материала';
        this.showErrorSnackbar(msg);
      }
      this.replaceLoading = false;
    },
  },
  mounted() {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    this.loadEntrances();
    this.loadMaterials();
  },
  unmounted() {
    document.getElementsByTagName('body')[0].style.overflow = '';
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar };
  },
};
</script>

<style scoped lang="scss">
.change__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #eee;
}
</style>
